@let disabled = disabled$ | async;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [disabled]="disabled"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [config]="config"
  [alignment]="alignment">
  <input
    #inputRef
    type="checkbox"
    class="app-checkbox"
    appYesNoValueCheckbox
    [formControl]="control"
    [name]="officeField.VistaFormItem.ColumnName" />
</app-control-wrapper>
